import { useEffect, useState } from 'react';
import { alternarTema, aplicarTema, gravarTema, lerTemaSalvo } from '@/helpers/tema.helpers';
import type { Tema } from '@/types/tema.types';

export type EstadoTema = {
  tema: Tema;
  alternar: () => void;
};

/**
 * Preferência de tema da página.
 *
 * O estado inicial vem do que já está gravado, e não de um valor fixo: o `index.html`
 * aplicou esse mesmo tema antes da primeira pintura, e começar com outro faria a página
 * piscar no primeiro render — justo o que o script inline existe para evitar.
 */
export function useTema(): EstadoTema {
  const [tema, setTema] = useState<Tema>(lerTemaSalvo);

  useEffect(() => {
    aplicarTema(tema);
  }, [tema]);

  return {
    tema,
    alternar: () =>
      setTema((atual) => {
        const proximo = alternarTema(atual);

        gravarTema(proximo);

        return proximo;
      }),
  };
}
